import { Tabs } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import MaterialTableComponent from "@components/MaterialTableComponent";
import LogisticService from "@LogisticService";

const AbasDeDetalhamento = (props) => {
  const { TabPane } = Tabs;
  const { nome, polo, ano, mes, tipo, resultado, distrito } = props;

  const [tabOneContent, setTabOneContent] = useState(resultado);
  const [tabTwoContent, setTabTwoContent] = useState(undefined);
  const [tabThreeContent, setTabThreeContent] = useState(undefined);
  const [tabFourContent, setTabFourContent] = useState(undefined);

  useEffect(() => {
    setTabOneContent(props.resultado);
  }, [props]);

  function formatDate(date, hours) {
    if (date !== undefined) {
      var datePart = date.slice(0, 10);

      if (hours === undefined) {
        return (
          datePart.split("-")[2] +
          "/" +
          datePart.split("-")[1] +
          "/" +
          datePart.split("-")[0]
        );
      }

      return (
        datePart.split("-")[2] +
        "/" +
        datePart.split("-")[1] +
        "/" +
        datePart.split("-")[0] +
        " " +
        date.slice(11)
      );
    } else {
      return "--/--/--";
    }
  }

  function callback(key) {
    if (key === "1" && tabOneContent === undefined) {
      setTabOneContent([]);
    }

    if (key === "2" && tabTwoContent === undefined) {
      LogisticService.getTriagensDistrito(ano, mes, distrito).then(
        (response) => {
          setTabTwoContent(
            response.data.data.map((terminal) => {
              const date = terminal.screening_date.slice(0, 10).split("-");
              return {
                serial: terminal.serial,
                status_before: terminal.status_before,
                status_after: terminal.status_after,
                screening_date: date[2] + "/" + date[1] + "/" + date[0],
                hub: terminal.provider,
                week_number: terminal.week_number,
              };
            })
          );
        }
      );
    }

    if (key === "3" && tabThreeContent === undefined) {
      LogisticService.getTerminaisRemovidosDistrito(ano, mes, distrito).then(
        (response) => {
          setTabThreeContent(
            response.data.data.map((terminal) => ({
              serial_uninstalled: terminal.serial_uninstalled,
              status_before: terminal.status_before,
              service_order_number: terminal.service_order_number,
              contractor: terminal.contractor,
              service_group: terminal.service_group,
              removal_date: formatDate(terminal.removal_date),
              week_number: terminal.week_number,
              provider: terminal.provider,
            }))
          );
        }
      );
    }

    if (key === "4" && tabFourContent === undefined) {
      LogisticService.getEstoqueDistrito(ano, mes, distrito).then(
        (response) => {
          setTabFourContent(
            response.data.data.map((customer) => ({
              serial: customer.serial,
              status: customer.status,
              provider: customer.provider,
              district: customer.district,
              photoDate: moment(customer.photo_date).format("DD/MM/YYYY"),
            }))
          );
        }
      );
    }
  }

  return (
    <Tabs defaultActiveKey="1" onChange={callback}>
      <TabPane tab="Resumo" key="1">
        <div style={{ padding: "0px 100px" }}>
          <MaterialTableComponent
            columns={[
              { title: "Pilar", field: "name" },
              { title: "Atingimento", field: "score" },
              { title: "Limite Máximo", field: "limit" },
            ]}
            options={{
              showTitle: false,
              search: false,
              paging: false,
              toolbar: false,
            }}
            data={
              !tabOneContent
                ? []
                : Object.values(tabOneContent).map((p) => {
                    return {
                      name: p.nome,
                      score: p.atingimento + "%", //resultado[p],
                      limit:
                        p.indicadores
                          .filter((i) => i.tipo !== "alavanca")
                          .map((i) => parseFloat(i.peso))
                          .reduce((a, b) => a + b, 0)
                          .toFixed(1) + "%",
                      indicadores: p.indicadores,
                    };
                  })
            }
            detailPanel={(rowData) => {
              return (
                <div style={{ padding: "30px 0px" }}>
                  <MaterialTableComponent
                    columns={[
                      {
                        title: "Indicador",
                        field: "indicador",
                      },
                      {
                        title: "Resultado",
                        field: "resultado",
                      },
                      {
                        title: "Atingimento Pós-Régua",
                        field: "atingimento_regua",
                      },
                      {
                        title: "Peso",
                        field: "peso",
                      },
                      {
                        title: "Impacto no Pilar",
                        field: "contribuicao_total",
                      },
                    ]}
                    data={rowData.indicadores.map((indicador) => ({
                      indicador: indicador.nome,
                      resultado: indicador.resultado,
                      atingimento_regua: indicador.atingimento + "%",
                      peso:
                        indicador.tipo === "alavanca"
                          ? indicador.atingimento >= 0
                            ? "Bônus"
                            : "Ônus"
                          : indicador.peso + "%",
                      contribuicao_total:
                        indicador.tipo === "alavanca"
                          ? indicador.atingimento + "%"
                          : (indicador.atingimento / 100) * indicador.peso +
                            "%",
                    }))}
                    addOptions={{
                      filtering: false,
                      pageSize: 5,
                      exportButton: false,
                      search: false,
                      paging: false,
                      toolbar: false,
                    }}
                  />
                </div>
              );
            }}
          />
        </div>
      </TabPane>
      <TabPane tab="Terminais Triados" key="2">
        <MaterialTableComponent
          columns={[
            {
              title: "Serial",
              field: "serial",
              cellStyle: { fontSize: "0.8em", width: "8em" },
            },
            {
              title: "Status Antes",
              field: "status_before",
              cellStyle: { fontSize: "0.8em", width: "3em" },
            },
            {
              title: "Status Depois",
              field: "status_after",
              cellStyle: { fontSize: "0.8em", width: "10em" },
            },
            {
              title: "Polo",
              field: "hub",
              cellStyle: { fontSize: "0.8em", width: "15em" },
            },
            {
              title: "Data da Triagem",
              field: "screening_date",
              cellStyle: { fontSize: "0.8em", width: "15em" },
            },
            {
              title: "Semana",
              field: "week_number",
              type: "numeric",
              cellStyle: { fontSize: "0.8em", width: "15em" },
            },
          ]}
          data={tabTwoContent}
          isLoading={!tabTwoContent}
          title="Terminais Triados"
        />
      </TabPane>
      <TabPane tab="Terminais Retirados" key="3">
        <MaterialTableComponent
          columns={[
            {
              title: "Número da OS",
              field: "service_order_number",
              cellStyle: { fontSize: "0.8em", width: "10em" },
            },
            {
              title: "Contratante",
              field: "contractor",
              cellStyle: { fontSize: "0.8em", width: "10em" },
            },
            {
              title: "Grupo de Serviço",
              field: "service_group",
              cellStyle: { fontSize: "0.8em", width: "10em" },
            },
            {
              title: "Serial",
              field: "serial_uninstalled",
              cellStyle: { fontSize: "0.8em", width: "8em" },
            },
            {
              title: "Polo",
              field: "provider",
              cellStyle: { fontSize: "0.8em", width: "15em" },
            },
            {
              title: "Data da Retirada",
              field: "removal_date",
              cellStyle: { fontSize: "0.8em", width: "15em" },
            },
            {
              title: "Semana",
              field: "week_number",
              type: "numeric",
              cellStyle: { fontSize: "0.8em", width: "15em" },
            },
          ]}
          data={tabThreeContent}
          isLoading={!tabThreeContent}
          title="Terminais Retirados"
        />
      </TabPane>
      <TabPane tab="Ciclo Triagem" key="4">
        <MaterialTableComponent
          columns={[
            {
              title: "Serial",
              field: "serial",
              cellStyle: { fontSize: "0.8em", width: "3em" },
            },
            {
              title: "Status",
              field: "status",
              cellStyle: { fontSize: "0.8em", width: "3em" },
            },
            {
              title: "Polo",
              field: "provider",
              cellStyle: { fontSize: "0.8em", width: "8em" },
            },
            {
              title: "Distrito",
              field: "district",
              cellStyle: { fontSize: "0.8em", width: "5em" },
            },
            {
              title: "Data da Foto",
              field: "photo_date",
              cellStyle: { fontSize: "0.8em", width: "15em" },
            },
          ]}
          data={tabFourContent}
          isLoading={!tabFourContent}
          title="Ciclo Triagem"
        />
      </TabPane>
    </Tabs>
  );
};

export default AbasDeDetalhamento;
